import React from "react"
import { Box, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"

import {
  ContentContainer,
  SourceDescription,
  CenterContainer,
  RecipientContainer,
  ButtonTransfer,
  StyledButton,
} from "./styled"
import IconBox from "../../../components/IconBox"
import UIIcon from "../../../components/UIIcon"
import SBPIconNoExt from "../../../components/SBPIconNoExt"

const PushForbidden = () => {
  const navigate = useNavigate()
  const handleClickBack = () => {
    navigate("/")
  }

  return (
    <ContentContainer>
      <CenterContainer>
        <IconBox size="lg" color="yellow">
          <UIIcon iconName="alertIcon" size={80} />
        </IconBox>
        <SourceDescription variant="h3">
          Запрос на перевод на свой счет отменен
        </SourceDescription>
        <RecipientContainer>
          <Typography variant="h4">Истекло время ожидания</Typography>
        </RecipientContainer>
      </CenterContainer>
      <Box sx={ButtonTransfer}>
        <SBPIconNoExt size={60} />
        <StyledButton
          variant="contained"
          color="secondary"
          onClick={handleClickBack}
        >
          Закрыть
        </StyledButton>
      </Box>
    </ContentContainer>
  )
}

export default PushForbidden
